import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'app-conversation',
  templateUrl: './conversation.component.html',
  styleUrls: ['./conversation.component.scss'],
})
export class ConversationComponent implements OnInit {
  @Input() conversation;
  @Input() isSelected: any;
  @Output() viewConversation: EventEmitter<any> = new EventEmitter();
  constructor() {}
  ngOnInit(): void {}
  getAcronym(inputString) {
    const words = inputString.split(' ');
    let acronym = '';
    words.forEach((word) => {
      if (word) {
        acronym += word[0].toUpperCase();
      }
    });
    return acronym.substring(0, 2);
  }
  viewMessages(item: any) {
    this.viewConversation.emit(item);
  }
}
